module.exports = __webpack_public_path__ + "static/img/223_TO8_1947_og.5d55399.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/223_TO8_1947_og.jpg
// module id = gm3A
// module chunks = 0